import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import Handlebars from "handlebars";
import { camelCase } from "lodash";
import Vue from "vue";
import { ENVIRONMENT, PREDEFINED_PAYMENT_PLANS } from "../constants";
export const mainSiteDomain = () => {
  let domain = "doorr.com";
  const env = ENVIRONMENT !== "production" ? "test." : "";
  return `https://${env}${domain}`;
};
export const getOverrideTarget = (target, overrides) => {
  const {
    overrideForm,
    overrideLogo,
    overrideFaq,
    overrideStyle
  } = overrides;
  const targets = {
    themes: {
      overrideLogo: overrideLogo,
      overrideStyle: overrideStyle
    },
    faq: {
      overrideFaq: overrideFaq
    },
    applicationForm: {
      overrideForm: overrideForm
    }
  };
  return _JSON$stringify(targets[target]);
};
export const enabledOption = (settingsOverrides, target) => {
  if (settingsOverrides[target] === true) return "disabled";
};
export const enabledForPlan = (session, type) => {
  const {
    permissions
  } = session;
  const permission = permissions[type];
  if (permission !== "write") {
    return "disabled";
  }
};
export const accountIsBroker = () => {
  const {
    accountType
  } = Vue.auth.session.get().accountDetails;
  return accountType === "broker";
};
export const matchesAccountType = allowedTypes => {
  const {
    accountType
  } = Vue.auth.session.get().accountDetails;
  return _includesInstanceProperty(allowedTypes).call(allowedTypes, accountType);
};
export const paymentPlans = () => PREDEFINED_PAYMENT_PLANS;
export const shouldBeChecked = (overrideTarget, page) => {
  page = camelCase(page);
  overrideTarget = JSON.parse(overrideTarget);
  const targets = {
    themes: "overrideStyle",
    faq: "overrideFaq",
    applicationForm: "overrideForm"
  };
  const currentTarget = targets[page];
  if (overrideTarget[currentTarget] === true) return new Handlebars.SafeString("checked");
  return;
};
export const isProduction = ENVIRONMENT === "production";
export const portalDomain = (portal, subdomain) => {
  const protocol = "https://";
  let {
    accountSubdomain
  } = Vue.auth.session.get().accountDetails;
  let domain = "doorr.com";
  let portalSubdomain = "";
  if (subdomain === "false") accountSubdomain = "";
  if (portal === "client") {
    domain = "mortgage";
    portalSubdomain = !isProduction ? `${ENVIRONMENT}.getmy` : "getmy";
  } else {
    portalSubdomain = !isProduction ? `${portal}-${ENVIRONMENT}` : portal;
  }
  return `${protocol}${portalSubdomain}.${domain}/${accountSubdomain}`;
};
export const registerHandlebarHelpers = _Handlebars => {
  _Handlebars.registerHelper("getOverrideTarget", getOverrideTarget);
  _Handlebars.registerHelper("enabledOption", enabledOption);
  _Handlebars.registerHelper("enabledForPlan", enabledForPlan);
  _Handlebars.registerHelper("accountIsBroker", accountIsBroker);
  _Handlebars.registerHelper("matchesAccountType", matchesAccountType);
  _Handlebars.registerHelper("paymentPlans", paymentPlans);
  _Handlebars.registerHelper("shouldBeChecked", shouldBeChecked);
  _Handlebars.registerHelper("portalDomain", portalDomain);
  _Handlebars.registerHelper("mainSiteDomain", mainSiteDomain);
};